import { Fancybox } from '@fancyapps/ui'

export default function FancyboxInit() {
  if (
    document.querySelectorAll('[data-fancybox]').length > 0 &&
    typeof Fancybox !== 'undefined'
  ) {
    console.log('Fancybox initialized')
    Fancybox.bind('[data-fancybox]', {
      Thumbs: { autoStart: true },
      Toolbar: { display: ['zoom', 'close'] }
    })
  }
}
